export default "__VITE_ASSET__Da6wwWU0__"